import { MenuToggle, DropdownList, DropdownItem, Dropdown, MenuToggleElement } from '@patternfly/react-core';
import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { supportedLanguages } from "../../i18n";

import './UserSettings.css';
import { appConfigSelectors } from "../../store/appConfig/appConfigSlice";
import { configurationTargetSelectors } from "../../store/configurationTarget/configurationTargetSlice";
import TabbedSupportedModelTypes from '../../components/TabbedSupportedModelTypes/TabbedSupportedModelTypes';
import ConfigurationTargetBoxDetailsContour from "./ConfigurationTargetBoxDetailsContour";
import ConfigurationTargetBoxDetailsDose from "./ConfigurationTargetBoxDetailsDose";
import { ModelType } from '../../store/global-types/customization-types';
import ConfigurationTargetBoxDetailsImage from './ConfigurationTargetBoxDetailsImage';
import ConfigurationTargetBoxDetailsAdapt from './ConfigurationTargetBoxDetailsAdapt';

const UserSettings = () => {

    const { t, i18n } = useTranslation();

    const [isLangDropdownOpen, setIsLangDropdownOpen] = React.useState(false);

    const deploymentInfo = useSelector(appConfigSelectors.selectAppDeploymentInfo);
    const currentConfigurationTarget = useSelector(configurationTargetSelectors.selectCurrent);

    const handleLangDropdownToggle = useCallback((isOpen: boolean) => {
        setIsLangDropdownOpen(isOpen);
    }, []);

    const onLangSelect = useCallback((nextLang: string) => {
        const langKey = supportedLanguages.find(l => l.label === nextLang)?.langKey;
        i18n.changeLanguage(langKey);
    }, [i18n]);

    const handleLangSelect = useCallback((event?: React.MouseEvent<Element, MouseEvent>) => {
        setIsLangDropdownOpen(false);
        onLangSelect((event?.target as HTMLElement)?.innerText || '')
    }, [onLangSelect]);

    // show supported languages, but filter out languages set as omitted from UI in config.json
    const langItems = supportedLanguages.filter(l => !deploymentInfo || !deploymentInfo.omitLocalizationsFromUi || !deploymentInfo.omitLocalizationsFromUi.includes(l.langKey))
        .map(l => (<DropdownItem key={l.langKey} value={l.langKey} size={2}>{l.label}</DropdownItem>))
    const currentLanguage = supportedLanguages.find(l => l.langKey === i18n.resolvedLanguage)?.label;

    return (
        <div className="user-settings" data-testid="user-settings-modal-content">

            <div className="setting-item">
                <span className="label">{t('settings.language')}</span>
                <span className="value">
                    <Dropdown
                        toggle={(toggleRef: React.Ref<MenuToggleElement>) => (
                            <MenuToggle ref={toggleRef} onClick={() => handleLangDropdownToggle(!isLangDropdownOpen)} isExpanded={isLangDropdownOpen}>
                                {currentLanguage}
                            </MenuToggle>)
                        }
                        isOpen={isLangDropdownOpen}
                        onSelect={handleLangSelect}
                        shouldFocusFirstItemOnOpen={false}
                        onOpenChange={() => handleLangDropdownToggle(!isLangDropdownOpen)}>
                            
                            <DropdownList>{langItems}</DropdownList>
                    </Dropdown>
                </span>
            </div>

            {!currentConfigurationTarget && (
                <div className="setting-item">
                    <div className="no-configuration-target-message selectable">
                        {t('settings.noConfigurationTargetMessage')}
                    </div>
                </div>
            )}

            <TabbedSupportedModelTypes
                hasNoBorderBottom
                content={[
                    { modelType: ModelType.Contouring, content: <ConfigurationTargetBoxDetailsContour /> },
                    { modelType: ModelType.Dose, content: <ConfigurationTargetBoxDetailsDose /> },
                    { modelType: ModelType.Image, content: <ConfigurationTargetBoxDetailsImage /> },
                    { modelType: ModelType.Adapt, content: <ConfigurationTargetBoxDetailsAdapt /> },
                ]}
            />

        </div >
    );
}

export default UserSettings;
